import {useEffect, useRef, useState} from "react";
import {recordPageViewMetric} from "../../services/AnalyticsRecorder";
import {PageView} from "../../enums/PageView";
import {isArrayNullUndefinedOrEmpty} from "../../services/Validator";
import SystemLeaveFlashDialog from "../../components/dialogs/SystemLeaveFlashDialog";
import FlashResultsTabletContentLayout from "../../components/layouts/courses/flash/FlashResultsTabletContentLayout";
import FlashResultsTabletSummary from "../../components/others/courses/flash/FlashResultsTabletSummary";
import FlashResultsTabletQuestionsCard from "../../components/cards/courses/flash/FlashResultsTabletQuestionsCard";
import FlashResultsDesktopContentLayout from "../../components/layouts/courses/flash/FlashResultsDesktopContentLayout";
import FlashResultsDesktopSummaryLayout from "../../components/layouts/courses/flash/FlashResultsDesktopSummaryLayout";
import FlashResultsDesktopScoreCard from "../../components/cards/courses/flash/FlashResultsDesktopScoreCard";
import FlashResultsDesktopGraphCard from "../../components/cards/courses/flash/FlashResultsDesktopGraphCard";
import FlashResultsDesktopQuestionsCard from "../../components/cards/courses/flash/FlashResultsDesktopQuestionsCard";
import NeoFlashResultsTopBar from "../../components/bars/flashScreen/NeoFlashResultsTopBar";

export default function NeoFlashResultsScreen({ levelA,
                                                questions,
                                                leaveFlash }) {
    // Used in MetaCoursesScreen component to display flash results made of global
    // score, graphical representation, and questions list with access to single
    // correction screen

    // PROPERTIES
    const [isModalOpen, setIsModalOpen] = useState(false)
    // ---- PageViewMetric
    const hasTrackedView = useRef(false)

    // HOOKS
    // ---- At rendering : if local flash is in storage, set flash variables
    useEffect(() => {
        if (!hasTrackedView.current) {
            // Avoid double trigger in dev, due to React Strict mode
            recordPageViewMetric(PageView.RESULTS);
            hasTrackedView.current = true;
        }
    }, []);

    // BUILD
    if (isArrayNullUndefinedOrEmpty(questions))
        return null;
    return(
        <div className="overflow-auto animate-appear w-full h-[100svh] bg-backgroundLight3 flex flex-col justify-start items-center">
            {/** MODAL */}
            <SystemLeaveFlashDialog open={isModalOpen}
                                    handleClose={processModalClosing}
                                    leave={leaveFlash} />
            {/** TOP BAR */}
            <NeoFlashResultsTopBar levelA={levelA}
                                   processModalOpening={processModalOpening} />
            {/** CONTENT */}
            <div className={"overflow-auto bg-backgroundLight3 w-full grow flex flex-col items-center"}>
                {/** ---- TABLET */}
                <FlashResultsTabletContentLayout>
                    <FlashResultsTabletSummary scores={computeFlashScores()[0]}
                                               total={questions?.length} />
                    <FlashResultsTabletQuestionsCard levelA={levelA}
                                                     questions={questions} />
                </FlashResultsTabletContentLayout>
                {/** ---- DESKTOP */}
                <FlashResultsDesktopContentLayout>
                    <FlashResultsDesktopSummaryLayout>
                        <FlashResultsDesktopScoreCard scores={computeFlashScores()[0]}
                                                      total={questions?.length} />
                        <FlashResultsDesktopGraphCard scores={computeFlashScores()[0]}/>
                    </FlashResultsDesktopSummaryLayout>
                    <FlashResultsDesktopQuestionsCard levelA={levelA}
                                                      questions={questions} />
                </FlashResultsDesktopContentLayout>
            </div>
        </div>
    );

    // METHODS
    // ---- LOGIC : Compute flash scores
    function computeFlashScores() {
        // Prepare
        let scores = [0, 0, 0]
        // Compute
        for (let i = 0; i < questions?.length; i++) {
            // Scores
            if (questions[i].selectedOption.isCorrect === null) {
                scores[2] += 1
            } else {
                questions[i].selectedOption.isCorrect ? scores[0] += 1 : scores[1] += 1
            }
        }
        // Return
        return [scores]
    }

    // ---- LOGIC : Open modal process
    function processModalOpening() {
        if (!isModalOpen) {
            setIsModalOpen(true);
        }
    }

    // ---- LOGIC : Close modal process
    function processModalClosing() {
        if (isModalOpen) {
            setIsModalOpen(false)
        }
    }
}